import APIServer from './APIServer'

const events = {
  EVENT_VIEW: 'event_view',
  APP_OPEN: 'APP_OPEN',
  USER_LOGGED_OUT: 'USER_LOGGED_OUT',
  USER_ONBOARD_START: 'USER_ONBOARD_START', 
  USER_ONBOARD_FINISH: 'USER_ONBOARD_FINISH',
  USER_CREATED_ACCOUNT: 'USER_CREATED_ACCOUNT',
  USER_VIEWED_PROFILE: 'USER_VIEWED_PROFILE',
  USER_UPDATED_USERNAME: 'USER_UPDATED_USERNAME',
  USER_UPLOADED_IMAGE: 'USER_UPLOADED_IMAGE',
  USER_VIEWED_EVENT_DETAIL: 'USER_VIEW_EVENT', 
  USER_COMMENTED_ON_EVENT: 'USER_COMMENTED_ON_EVENT',
  USER_OPENED_EVENT_LOCATION: 'USER_OPENED_EVENT_LOCATION',
  USER_CLICKED_TICKET: 'USER_CLICKED_TICKET',
  USER_WATCHED_VIDEO: 'USER_WATCHED_VIDEO'
};


class Analytics extends APIServer {  

	constructor(props) { 
		super(props)
		if (!Analytics.instance) { 
			Analytics.instance = this
		}
		return Analytics.instance
	}

	async logEvent(event, body) { 
		if (event == undefined) { 
			return null
		}

  		body.label = event
  		return super.post("/analytics", body)
	}
}

const AnalyticsManager = new Analytics()

export {AnalyticsManager, events}